import React from "react";
import {
  Button,
  Grid,
  Header,
  List,
  Segment,
  Message,
  Form
} from "semantic-ui-react";
import { BrowserRouter as Router, Link, Route } from "react-router-dom";

import { CustomMessage, Navbar } from "components";
import Home from "./Home";
import ContactUs from "./ContactUs";
import Team from "./Team";
import Mobile from "./Mobile";

import "styling/semantic.less";

const leftItems = [
  {
    as: "a",
    content: "Gluten Free Labs",
    href: "/",
    key: "docs"
  }
];
const rightItems = [
  {
    as: "a",
    content: "ABOUT",
    href: "/about"
  },
  {
    as: "a",
    content: "CONTACT",
    href: "/contact"
  }
];

const App = () => (
  <Router>
    <Navbar leftItems={leftItems} rightItems={rightItems}>
      <Segment basic style={{ marginTop: 20 }}>
        <Route path="/about" component={Team} />
        <Route path="/contact" component={ContactUs} />
        <Route exact={true} path="/" component={Home} />
      </Segment>
    </Navbar>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js